<template>
  <button
    class="ar-toggle button is--solid is--blue has--icon"
    @click="handleClick()"
    v-if="iframeSrc"
  >
    <span class="text">
      Se porten på ditt hus
    </span>
    <span class="icon">
      <svg width="25" height="22" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12.037.113a1 1 0 0 1 .926 0L19 3.263V1.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v3.328l2.463 1.285a1 1 0 0 1 .53.764L25 7v2a1 1 0 0 1-1.463.887L22 9.084V21h1.5a.5.5 0 0 1 0 1h-22a.5.5 0 0 1 0-1H3V9.084l-1.537.803a1 1 0 0 1-1.438-.66l-.019-.11L0 9V7a1 1 0 0 1 .537-.887zm.463 4.015L4 8.562V21h17V8.562l-8.5-4.434zM17 9a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1zm-5 5H8v3h4v-3zm5 0h-4v3h4v-3zm-9-4v3h4v-3H8zm4.5-9L1 7v2l11.5-6L24 9V7L12.5 1zM21 2h-1v1.785l1 .522V2zm-8 11h4v-3h-4v3z"
          fill="#FFF"
          fill-rule="nonzero"
        />
      </svg>
    </span>
  </button>
</template>

<script>
export default {
  props: ['iframeSrc'],
  methods: {
    handleClick() {
      bus.$emit('iframe_modal_toggle', this.iframeSrc)
    },
  },
}
</script>
